import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { selectMentorsQueryItems } from '../../../../redux/mentors/selector';
import { mentors } from '../../../../redux/mentors/action';
import MentorsComponent from '../components/mentor.component';
import { settings } from '../../../../redux/settings/actions';
import UploadFiles from '../../../../models/UploadFile';
import { selectCurrent } from '../../../../redux/settings/selectors';


const ManagementVenture = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const mentorsItems = useSelector(selectMentorsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [openConfirmationPhotoFile, setOpenConfirmationPhotoFile] = React.useState(false);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const { getUploadFiles } = useAppSelector(selectCurrent)

  const librariesItems = storePersist?.get("library")?.current;

  const [selectedMentors, setSelectedMentors] = useState<any>([])
  const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},


  })

  const handleClose = () => {
    if (openConfirmationPhotoFile) {
      setOpenConfirmationPhotoFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  const fetchMentorsQueryById = () => {

    dispatch(mentors.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/mentors/query`, entity: 'mentors', jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })

  }





  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedMentors({ ...selectedMentors, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  useEffect(
    () => {


      if (parmas?.id > 0) {
        fetchMentorsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }



    },
    []
  )

  useEffect(
    () => {

      if (isQuery) {
        setSelectedMentors(mentorsItems?.result?.items)
      }
    },
    [isQuery]
  )



  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(mentors.resetAction({ actionType: 'update' }))
      await dispatch(mentors.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/mentors`,
        entity: 'mentors',
        jsonData: {

          Records: [
            {
              ...selectedMentors

            }

          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(mentors.resetAction({ actionType: 'create' }))
      await dispatch(mentors.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/mentors`,
        entity: 'mentors',
        jsonData: {

          Records: [
            {
              ...selectedMentors
            }
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  //image picker 
  const changeImage = (templateField: any, fileType: any, selectedMentors: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationPhotoFile(true)
    setOpenImageFile({
      currentFileSrc: selectedMentors?.PhotoUrl || templateField,
      folder: 'mentors',
      type: fileType
    })


  }

  const handlePhotoSubmit = (data: any) => {
    const photoData = {
      PhotoUrl: data
    }
    setSelectedMentors({ ...selectedMentors, ...photoData })
  }
  //image picker 

  const back = () => {
    navigate('/management/e-applications/onesp/mentors')
  }
  return (
    <>
      {getUploadFiles == 'open' && openConfirmationPhotoFile &&
        <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
          folder={openImageFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handlePhotoSubmit}
          type={openImageFile?.type}
          ownerId={parmas?.id}
        />
      }
      {isLoading ? <PageLoader /> :
        <MentorsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedMentors={selectedMentors}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
          selectedAddress={selectedAddress}
          changeImage={changeImage}



        />
      }
    </>
  )

}

export default ManagementVenture;